import React from "react";
import DropdownButtonView from "presentational/common/DropdownButtonView";
import TXT from "presentational/common/multinational/TXT";
import { withStore } from "store/storeHandler";
import { getLangType } from "lib/commonUtil";
import { translationIndex } from "lib/translationIndex";
import PropTypes from "prop-types";

ItemCategoryDropdownButtonView.propTypes = {
  dropdownName: PropTypes.string.isRequired,
  categoryList: PropTypes.array.isRequired,
  selectedItem: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disableRightMargin: PropTypes.bool
};

ItemCategoryDropdownButtonView.defaultProps = {
  disableRightMargin: false
};

function ItemCategoryDropdownButtonView(props) {
  const {
    dropdownName,
    categoryList,
    selectedItem,
    onSelect,
    disableRightMargin,
    viewerLocation
  } = props;

  const sortArray = list => {
    let firstElem = list[0];
    let sortedList = list
      .slice(1)
      .sort((a, b) => a.innerText.localeCompare(b.innerText));

    sortedList.unshift(firstElem);
    return sortedList;
  };

  const getCategoryIndexList = () => {
    const rawCategoryList = categoryList.map(oneValue => ({
      value: oneValue,
      text: (
        <TXT textType="category" categoryType="itemLabelName" name={oneValue} />
      ),
      innerText:
        translationIndex.categoryList.data[oneValue][
          getLangType(viewerLocation)
        ]["itemLabelName"]
    }));
    return sortArray(rawCategoryList);
  };

  return (
    <DropdownButtonView
      dropdownName={dropdownName}
      menuList={getCategoryIndexList()}
      selectedItem={selectedItem}
      onSelect={onSelect}
      prefixText={<TXT name="btnSelect_category" />}
      disableRightMargin={disableRightMargin}
    />
  );
}

export default withStore({
  stateMap: {
    userDevice: ["viewerLocation"]
  }
})(ItemCategoryDropdownButtonView);
